import { useEffect, useState } from "react";
import { getDynamicData } from "../service/base-url";
import BlockOne from "../components/AboutPage/BlockOne";
import { useSelector } from "react-redux";
import NewSwiper from "../components/Swiper/NewSwiper";

const About  = () => {
  const [aboutData, setAboutData] = useState()
  const language = useSelector((state) => state.language.language);

  useEffect(() => {
    getDynamicData('aboutUs', setAboutData, null, language)
  }, [language])

    return (
    <div>
      <NewSwiper data={aboutData?.slider_images ?? []} />
      <BlockOne data={aboutData} />
    </div>
  )
}

export default About
